import React from 'react';
import './App.css';
import WaitlistForm from './components/WaitlistForm';

function App() {
  return (
    <div className="min-h-screen bg-gradient-dark text-white flex flex-col">
      {/* Dark floating background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-3/4 right-1/4 w-80 h-80 bg-dark-purple-500/15 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-3/4 w-64 h-64 bg-purple-400/10 rounded-full blur-2xl"></div>
      </div>
      
      <nav className="container mx-auto px-6 py-6 relative z-10">
        <div className="flex items-center justify-center">
          <img src="/vibemuch-logo.svg" alt="VibeMuch Logo" className="h-12 drop-shadow-lg" />
        </div>
      </nav>

      <main className="container mx-auto px-6 py-16 relative z-10 flex-grow">
        <div className="text-center max-w-5xl mx-auto mb-12">
          <h1 className="text-6xl md:text-8xl font-bold mb-8 bg-gradient-to-r from-white via-purple-200 to-purple-300 bg-clip-text text-transparent leading-tight">
            European AI IDE
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
            Join the waitlist for early access.
          </p>
        </div>

        <WaitlistForm />
      </main>

      <footer className="bg-black/50 backdrop-blur-sm py-16 relative z-10 border-t border-purple-800/30">
        <div className="container mx-auto px-6 text-center">
          <p className="text-gray-400 text-lg">&copy; 2025 VibeMuch. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App; 